<template>
	<v-container grid-list-xl fill-height ref="row" >
	  <v-row  justify="center" >
	  	<v-snackbar
        v-model="snackbar"
        :timeout="8000"
        top
        color="orange" dark
      >
        {{msg}}
        <v-btn
          color="white"
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>

	  	<v-col cols="12" xl="10" xs="12" >
		  	<v-card class="elevation-0">
		  		<v-card-text >
			  		<v-row>	 
			  		  <!-- Imageb y botones de pagar, cotizar e imprimir -->
					  	<v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
					  		<v-card class="elevation-0 transparent" align="left">
					  		  <v-row >
					  		    <v-col cols="12" xl="6" lg="6" md="6" sm="6" xs="12">
					  		  		<v-img :src="logo" alt="alt"  width="175"/>
					  		    </v-col>
					  		    <v-col cols="12" xl="6" lg="6" md="6" sm="6" xs="12">
					  		    	<v-card-actions >
					  		    		<v-spacer></v-spacer>
										    <v-btn color="amber darken-3" dark @click="order()" v-if="acceso==true">Agregar Pedido</v-btn>
					  		    	</v-card-actions>
					  		    </v-col>
					  		  </v-row>
					  		</v-card>
					  	</v-col>

					  	<!-- Datos de la tienda -->
					  	<v-col cols="12" xs="6" class="py-0">
					  	  <v-card class="elevation-0">
					  	    <v-card-text class="py-0">
					  	    	<div class="text-xs-left "><strong>{{ tienda.nomcia }}</strong></div>
					  	    	<div class="text-xs-left "><strong>{{ tienda.rfccia }}</strong></div>
					  	    	<div class="text-xs-left ">{{ direccionCia }}</div>
					  	    	<div class="text-xs-left ">{{ tienda.email }}</div>
					  	    	<div class="text-xs-left ">{{ tienda.telefono }}</div>
					  	    </v-card-text>
					  	  </v-card>
					  	</v-col>

					  	<!-- Nota -->
							<v-col cols="12" xs="6" class="py-0">
					  	  <v-card class="elevation-0">
					  	    <v-card-text class="py-0">
					  	    Antes de pagar, necesitas crear un pedido	
					  	    </v-card-text>
					  	  </v-card>
					  	</v-col>

					  	<!-- Datos del cliente -->
					  	<v-col cols="12" xl="6" lg="6" md="6" sm="6" xs="12" v-if="usuario">
					  		<v-card class="elevation-0">
					  		  <v-card-text >
					  		    <div class="text-xs-left "><strong>Datos del cliente</strong></div>
					  		    <div class="text-xs-left "><strong>{{ usuario.rfc }}</strong></div>
					  		    <div class="text-xs-left ">{{ usuario.nomcomer }}</div>
					  		    <div class="text-xs-left ">{{ direccionUser }}</div>
					  		    <div class="text-xs-left ">{{ usuario.telefono }}</div>
					  		    <div class="text-xs-left ">{{ usuario.email }}</div>
					  		  </v-card-text>
					  		</v-card>
					  	</v-col>

					  	<v-col cols="12" xl="6" lg="6" md="6" sm="6" xs="12" v-else>
					  		<v-card outlined>
					  		  <v-card-text >
					  		    <h2><strong>Agrega tus datos fiscales, en ajustes.</strong></h2>
					  		  </v-card-text>
					  		</v-card>
					  	</v-col>

					  	<!-- Datos generales -->
					  	<v-col cols="12" xl="6" lg="6" md="6" sm="6" xs="12">
				  			<v-card class="elevation-0">
					  		  <v-card-text>
					  		    <div class="text-xs-left "><strong>Fecha: </strong>{{ fecha }}</div>
					  		    <div class="text-xs-left "><strong>Tipo Doc: </strong>Cotización</div>
					  		    <div class="text-xs-left "><strong>Divisa: </strong>MXN</div>
					  		  </v-card-text>
					  		</v-card>
					  	</v-col>

					  	<!-- Dirección de envío -->
					  	<v-col cols="12" xl="6" lg="6" md="6" sm="6" xs="12">
				  			<v-card class="elevation-0">
				  				<v-card-text>
					  				<v-radio-group v-model="radios" :mandatory="false" row >
								      <v-radio label="Envío a domicilio" value="2" color="primary"></v-radio>
							      </v-radio-group>

							      <v-select 
							      	v-if ="radios==2"
                      v-model="direccion"
                      :hint="`  ${direccion.calle} ${direccion.numext} ${direccion.colonia} ${direccion.ciudad}
                      ${direccion.estado} CP ${direccion.cp}`"
                      :items="direcciones"
                      item-text="nomdir"
                      item-value="iddirecciones" 
                      label="Selecionar Dirección de envio"
                      prepend-icon="house"
                      persistent-hint
                      return-object
               
                    ></v-select>
										

					  		  </v-card-text>
					  		</v-card>
					  	</v-col>

					  	<v-col cols="12" xl="3" lg="4" md="6" sm="6" xs="12">
							  <v-row >
				    		  <v-col cols="6">
				    		  	<v-card class="transparent elevation-0">
				    		  	  <v-card-text>
				    		  	  	<div class="text-xs-left "><h3><strong>Importe:</strong></h3></div>
						    		    <div class="text-xs-left "><h3><strong>Descuento:</strong></h3></div>
						    		    <div class="text-xs-left "><h3><strong>Subtotal:</strong></h3></div>
						    		    <!-- <div class="text-xs-left "><h3><strong>Iva:</strong></h3></div> -->
						    		    <div class="text-xs-left "><h3><strong>Total:</strong></h3></div>
				    		  	  </v-card-text>
				    		  	</v-card>
				    		  </v-col>

				    		  <v-col cols="6">
				    		    <v-card class="transparent elevation-0">
				    		  	  <v-card-text align="right">
				    		  	  	<div class="text-xs-left "><h3><strong>{{ importedoc}}</strong></h3></div>
						    		    <div class="text-xs-left "><h3><strong>{{descuentodoc}}</strong></h3></div>
						    		    
						    		    <div class="text-xs-left "><h3><strong>{{ subtotal}}</strong></h3></div>
						    		    <!-- <div class="text-xs-left "><h3><strong>{{ iva}}</strong></h3></div> -->
						    		    <div class="text-xs-left "><h3><strong>{{ total }}</strong></h3></div>
				    		  	  </v-card-text>
				    		  	</v-card>
				    		  </v-col>
							  </v-row>
					  	</v-col>

					  	<!-- Tabla de articulos -->
						 	<v-col cols="12" xs="12" class="pa-2">
						 		<v-divider></v-divider> 
							  <template>
						    	<v-data-table
						      	:headers="headers"
						      	:items="getCarrito"
						      	fixed-header
                		class="elevation-1 pa-0 text-xs-center"
						      	hide-default-footer
						    	>
						    		<template v-slot:item.actions="{ item }">
								     <th>
								     	<v-icon @click="add(item)" color="success">add</v-icon>
								     	<v-icon @click="remove(item)" color="red">remove</v-icon>
								     </th>
								    </template>
						    		
						    		<template v-slot:item.foto="{ item }">
								      <v-img :src="url + item.foto" contain aspect-ratio="2"/>
								    </template>

							      <template v-slot:no-data>
							        <v-alert type="error" :value="true" class="mt-2">
							        	No hay articulos en tu carrito
							        </v-alert>
							      </template>
							    </v-data-table>
								</template>
						 	</v-col>
			  		</v-row>
		  		</v-card-text>
		  	</v-card>
	  	</v-col>
	  </v-row>	
	  <!-- COMPROBANTE -->
  </v-container>	
</template>

<script>

	import {mapActions, mapGetters, mapState} from 'vuex'
  var numeral = require('numeral');

	
  // import ModalCarrito from '@/views/pagos/ModalDireccion.vue'
  
  import tempCarrito from '@/mixins/tempCarrito.js';
	
	var accounting = require("accounting");
  var base64 = require('base-64');

	export default{
		mixins:[tempCarrito],
		// components:{
		// 	ModalCarrito
		// },

		data(){
			return{
				direccionUser:[],
				usuario:[],
				direccionCia:'',
				url: this.$http.options.root + 'fotos/',
				tienda:{},
				direcciones:[],

				direccion: {nombre:'', idweb:'', encargado:'',
								 Calle:'', Numext:'', colonia:'', Ciudad:'',
								 Estado:'', Cp:'', telefono:'', numclisuc:'' },
				
				logo:'',
				//copias
				email1:'',
				email2:'',

				dialog: false,
				acceso: true,
				tipoDoc:'',
				moneda:'',
				divisa:'',

				direccion:'',
				CargaCliente: [],
				msg:'',
				snackbar: false,


				importedoc:0.00,
        descuentodoc:0.00,
        total: 0.00,
        iva:0.00,
        subtotal:0.00,

				Movim:[],
				radios: '2',

				fecha: new Date().toISOString().substr(0, 10),
	      headers: [
	        { text: ''						,align: 'center', value: 'actions',     sortable: false },
	        { text: 'codigo'			  ,align: 'left', 	value: 'codigo'	,   	sortable: false },
	        { text: 'Foto'			  ,align: 'center', value: 'foto'	,     	sortable: false },
	        { text: 'Descripción' ,align: 'left', 	value: 'descrip',   	sortable: false },
	        { text: 'Cant'	      ,align: 'center', value: 'cantidad',  	sortable: false },
	        
	        { text: 'Precio'		  ,align: 'center', value: 'precio1'  ,  	sortable: false },
	        { text: 'Descuento'	  ,align: 'center', value: 'descuento',   sortable: false },
	        { text: 'Neto'		  	,align: 'center', value: 'total'  , 		sortable: false },
	      ],
	      comprobanteModal:0
			}
		},

		watch:{
			getCarrito: function(){
				this.crearArreglo()
			},

			radios: function(){
				if(this.radios == 2){
					this.dialog = true
					

				}
			}
		},

		computed: {
      ...mapGetters('carrito',['getCarrito']),
      ...mapGetters('login',['getdatosUsuario']),
      ...mapState('carrito',['carrito']),
      
    },

    watch:{
    	getCarrito: function(){
	    	this.crearArreglo()
	    }
    },


    created () {
    	this.init()
    	//Vaidamos si ya esta logeado
    	if(this.getdatosUsuario ==''){
    		this.msg = 'Aún no eres usuario'
	    	this.snackbar = true
	    	this.acceso = false
    	}
    },

    methods: {
      ...mapActions('carrito',['limpiarCarrito']),

      unformat(string) {
        console.log('string',string)
        return numeral._.stringToNumber(string);
      },


      init(){
      	this.crearArreglo()
      	this.getCorreos()
      	this.getDatosfiscales()
      	this.getDireccionUsuario()
      },

      getCorreos(){
      	this.$http.get('config.list').then(response=>{
	    		this.logo = this.$http.options.root + 'fotos/' + response.body.logourl
	    		this.email1  = response.body.email1
	        this.email2 = response.body.email2
	    	}, error => {console.log(error)})
      },

      getDatosfiscales(){
      	this.$http.get('tienda/datosfiscales').then(response=>{
	    		this.tienda = response.body[0]
	    		this.direccionCia  = this.tienda.calle + ', ' + this.tienda.numext + ', ' + this.tienda.colonia + ', ' + this.tienda.ciudad + ', ' + this.tienda.estado + ', ' + this.tienda.cp
	    	}, error => {console.log(error)})

	    	this.$http.get('datosfiscales.usuario/' + this.getdatosUsuario.idusuariosweb).then(response=>{
	    		this.usuario = response.body[0]
	    		this.direccionUser = this.usuario.calle + ', ' + this.usuario.numext + ', ' + this.usuario.colonia + ', ' + this.usuario.ciudad + ', ' + this.usuario.estado + ', ' + this.usuario.cp
	    	}, error => {console.log(error)})
      },

      getDireccionUsuario(){
      	this.$http.get('direcciones.usuario/' + this.getdatosUsuario.idusuariosweb).then(response=>{
	    		this.direcciones = response.body
	    	}).catch(error=>{console.log(error)})
      },
      
    	order(){
    		if(this.direccion == ''){
    			this.msg = 'Agrega tu Dirección de envío'
    			this.snackbar = true
    			return
    		}
    		// vemos que el carrito tenga articulos
    		if(this.getCarrito.length > 0){

	    		var docum = {
	    			idusuariosweb: this.getdatosUsuario.idusuariosweb,
	    			direccion: this.direccion.calle+', '+this.direccion.numext+', '+this.direccion.colonia+', '+this.direccion.ciudad + ', '+this.direccion.estado +', ' + this.direccion.cp,

	    			importe:   this.importedoc, 
	    			descuento: this.descuentodoc,
	    			subtotal: this.subtotal,
	    			total: this.total,
	    			iva: 0.00,
	    			folio:'',
		    		estatus:0,
		    		nota:'',
	    			divisa :'MXN',
		    		hora: this.hora(),
	    			fecha: new Date().toISOString().substr(0, 10),
	    			refer:'',
	    			tipodoc: 'P',
		    		movim: this.getCarrito,
		    	}

		    	// console.log("movim_array", this.movin_array)
	        this.$http.post('ordenes.add', docum).then(response=>{
			    	//Avisamos que se proceso correctamente la cotización
			    	this.msg = 'Cotización procesada correctamente'
		    		this.snackbar = true
		    		// Limpiar carrito
	          var value = []
	          this.limpiarCarrito(value)

	          setTimeout(() => (this.$router.push({name: 'miscompras'})), 3000)

	        }).catch(function(error){
	          console.log(error)
	        })
	      }
    		

    	},


    	hora(){
        var f =new Date();
      	var hora = f.getHours()
      	var minuto = f.getMinutes()
      	var segundo = f.getSeconds()   
        if(hora < 10){
          hora = "0" + f.getHours()
        }
        if(minuto < 10){
          minuto = "0" + f.getMinutes() 
        }
        if(segundo < 10){
          segundo = "0" + f.getSeconds()
        }
        return hora + ":" + minuto + ":" + segundo
			},

			 
			add(articulo){	
				//RECORRE EL CARRITO PARA LOACALIZAR LA codigo y subir la cantidad.
    		for (var i = this.getCarrito.length - 1; i >= 0; i--) {
    			if(this.getCarrito[i].codigo == articulo.codigo){
    				this.getCarrito[i].cantidad = this.getCarrito[i].cantidad + 1
    			}
    		}

  			this.crearArreglo()
    	},

    	remove(articulo){
    		for (var i = this.getCarrito.length - 1; i >= 0; i--) {
    			if(this.getCarrito[i].codigo == articulo.codigo){
    				this.getCarrito[i].cantidad = this.getCarrito[i].cantidad - 1
    				if(this.getCarrito[i].cantidad == 0 ){
    					this.getCarrito.splice(i, 1)
    				}
    			}
    		}
  			this.crearArreglo()
    	},

    	crearArreglo(){
    		this.formarCarrito()
    	},

    }
  }
</script>
